import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'sistema/publicidades',
		component: Base,
		children: [
			{
				path: '',
				name: 'PublicidadesList',
				component: List,
				meta: {
					path: '/sistema/publicidades',
					pai: 'Sistema',
					title: 'Admin - Publicidades',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Publicidades',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'PublicidadesNovo',
				component: Form,
				meta: {
					path: '/sistema/publicidades',
					pai: 'Sistema',
					title: 'Admin - Publicidades - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Publicidades',
						class: '',
						active: false,
						url: '/sistema/publicidades'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'PublicidadesEditar',
				component: Form,
				meta: {
					path: '/sistema/publicidades',
					pai: 'Sistema',
					title: 'Admin - Publicidades - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Publicidades',
						class: '',
						active: false,
						url: '/sistema/publicidades'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]